import {useQuery} from 'react-query';
import {getLoanRequestRule} from './getLoanRequestRule';

const useGetLoanRequestRule = (
  loanRequestGuid?: string,
  caching?: 'no-cache' | 'cache',
) => {
  const {data, isLoading, refetch, isSuccess} = useQuery(
    ['get-loan-request-rules', loanRequestGuid], // Dynamic queryKey based on loanRequestGuid
    () => getLoanRequestRule(loanRequestGuid), // Correct queryFn

    {
      enabled: Boolean(loanRequestGuid),
      cacheTime: caching === 'no-cache' ? 0 : 300000, // Cache time (0 for no cache)
      staleTime: caching === 'no-cache' ? 0 : 60000, // Stale time (0 for no stale)
      // refetchOnWindowFocus: caching === 'no-cache', // Always refetch when window refocuses
      refetchOnReconnect: caching === 'no-cache', // Always refetch on reconnect
      refetchInterval: caching === 'no-cache' ? 0 : undefined, // Prevent periodic refetch in no-cache mode
    },
  );

  return {data, isLoading, refetch, isSuccess};
};

export default useGetLoanRequestRule;
